export * from './definitions';
import { registerPlugin } from '@capacitor/core';
import { GetAppInfoWeb } from './web';
const GetAppInfo = registerPlugin('GetAppInfo', {
    web: () => new GetAppInfoWeb(),
});
export * from './definitions';
export { GetAppInfo };
//# sourceMappingURL=index.js.map